import { Component, OnInit, ChangeDetectionStrategy, Input, AfterContentInit, OnChanges, SimpleChanges, HostListener, Optional, Host, AfterViewInit, Output, EventEmitter, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { DropdownItemDirective as DropDownItem } from '../directives/dropdown-item.directive';
import { AutoCompleteComponent } from '../auto-complete.component';
import { fromEvent, Subject } from 'rxjs';
import * as _ from 'underscore';
import { DropdownTitleDirective as DropdownTitle } from '../directives/dropdown-title.directive';
import { IAutoCompleteSettings } from '../auto-complete.module';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'dropdown-container,[dropdown-container]',
    template: '<ng-content></ng-content>',
    styleUrls: ['./dropdown-container.component.css'],
    exportAs: 'dropDownContainer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropdownContainerComponent implements OnInit, OnChanges, AfterContentInit, AfterViewInit, OnDestroy {
  dropdownItems: Array<DropDownItem> = [];
  dropdownTitles: Array<DropdownTitle> = [];
  filteredItems: Array<DropDownItem> = [];
  @Input() searchValue;
  @Input() settings: IAutoCompleteSettings;
  @Output() afterFilter = new EventEmitter();
  componentDestroySubject = new Subject();

  constructor(private elementRef: ElementRef, @Optional() @Host() public autocomplete: AutoCompleteComponent, private cdref: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    this.search(this.searchValue);
  }
  ngOnInit() {
  }


  onkeydown(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      // event.stopImmediatePropagation();
      // event.stopPropagation();
      event.preventDefault();
    }
    if (event.keyCode === 32) {
      const inputElement = this.autocomplete.virtualKeyBoardRef.inputField.elementRef.nativeElement;
      const startPos = inputElement.selectionStart;
      if (!startPos) {
        event.preventDefault();
      }
    }

    if (this.dropdownItems.length && _.contains([40, 38, 13, 32, 46, 17], event.keyCode)) {
      const dropdownItems = _.uniq(this.dropdownItems, e => e.id);

      const filteredItems: DropDownItem[] = _.filter(dropdownItems, (item: DropDownItem) => item.isHidden === false);

      let selectedItem: DropDownItem = _.find(dropdownItems, (item: DropDownItem) => item.isActive === true);
      let index = -1;
      if (selectedItem) {
        index = filteredItems.indexOf(selectedItem)
        if (!_.contains([13, 17], event.keyCode)) {
          selectedItem.removeSelection()
        }
      }
      switch (event.keyCode) {
        case 40: // ArrowDown
          {
            event.preventDefault();
            const next = index === filteredItems.length - 1 ? filteredItems[0] : filteredItems[index + 1];

            if (index > -1) {
              selectedItem.removeSelection();
            }
            if (next) {
              next.selection();
              next.scrollIntoView(false);
            }
          }
          break;

        case 38: // ArrowUp
          {
            event.preventDefault();
            if (index === -1) {
              if (filteredItems[0]) {
                filteredItems[0].selection();
                filteredItems[0].scrollIntoView(false);
              }
            } else {
              const previous = index === 0 ? filteredItems[filteredItems.length - 1] : filteredItems[index - 1];
              selectedItem.removeSelection();
              if (previous) {
                previous.selection();
                previous.scrollIntoView(false);
              }
            }
          }
          break;
        case 13:// Enter
          // event.stopImmediatePropagation();
          this.selectOption();
          break;
        case 32: // space
          {
            const inputElement = this.autocomplete.virtualKeyBoardRef.inputField.elementRef.nativeElement;
            const startPos = inputElement.selectionStart;
            if (!startPos) {
              event.preventDefault();
            }
            this.autocomplete.show(true);
          }

          break;
        case 17: // ctrl
          // event.stopImmediatePropagation();
          // event.stopPropagation();          
          event.preventDefault();
          this.selectOption();
          this.autocomplete.focusFirstElementInForm(0)
          break;

      }
    }
    else if (!this.dropdownItems.length && _.contains([13, 17], event.keyCode)) {
      this.setDefaultForAutoCompleteFields(this.searchValue);

    }
  }

  selectOption() {

    let selectedItem: DropDownItem = _.find(this.dropdownItems, (item: DropDownItem) => item.isActive === true && item.isHidden === false);
    if (this.autocomplete.visible && !!selectedItem) {
      this.emitSelectedItem(selectedItem);
    } else {
      selectedItem = _.find(this.dropdownItems, (item: DropDownItem) => this.match(item, { searchFn: '===', searchKey: [this.settings.autoSelectKey] }));
      if (!selectedItem && this.settings.isSuggestion) {

        selectedItem = _.find(this.dropdownItems, (item: DropDownItem) => this.match(item, { searchFn: 'startsWith', searchKey: [this.settings.autoSelectKey, 'name'] }));
      }
      const activeOption = this.autocomplete.activeOption;
      if (selectedItem) {
        if (activeOption) {
          if (activeOption.name === selectedItem.item.name) {
            selectedItem.removeSelection();

            selectedItem = _.find(this.dropdownItems, (item: DropDownItem) => item.item.id === activeOption.id);

            this.emitSelectedItem(selectedItem);
          }
        } else {

          this.emitSelectedItem(selectedItem);
        }
      } else if (this.settings.isSuggestion && activeOption) {
        selectedItem = _.find(this.dropdownItems, (item: DropDownItem) => item.item.id === activeOption.id);

        this.emitSelectedItem(selectedItem);

      } else {
        if (this.searchValue && this.settings.isSuggestion) {
          selectedItem = _.find(this.dropdownItems, (item: DropDownItem) => this.match(item, { searchFn: 'startsWith', searchKey: [this.settings.autoSelectKey, 'name'] }));
          if (selectedItem) {

            this.emitSelectedItem(selectedItem);
          } else {
            this.setDefaultForAutoCompleteFields(this.settings.isSuggestion ? null : this.searchValue);

          }
        } else if (this.searchValue && !this.settings.isSuggestion) {
          this.setDefaultForAutoCompleteFields(this.searchValue);
        } else {
          this.setDefaultForAutoCompleteFields();

        }
      }

    }
    this.autocomplete.hide();

  }
  emitSelectedItem(selectedItem: DropDownItem) {
    if (selectedItem) {
      selectedItem.select.emit(selectedItem.item);
      selectedItem.removeSelection();

    } else {
      this.autocomplete.setvalue({ id: null, name: '' });
    }
  }
  setDefaultForAutoCompleteFields(value = null) {

    if (!value) {
      this.autocomplete.setvalue({ id: null, name: '' });
    } else {
      this.autocomplete.activeOption = value;
      this.autocomplete.change.emit(value);
      this.autocomplete.onChange(value);
    }
    this.autocomplete.hide();
  }
  ngAfterViewInit() {
    const input = this.autocomplete.virtualKeyBoardRef.inputField.elementRef.nativeElement;

    fromEvent(input, 'keydown').pipe(takeUntil(this.componentDestroySubject)).subscribe((event: KeyboardEvent) => {
      // this.autocomplete.keydown.emit(event);
      this.onkeydown(event);
    })
  }
  ngAfterContentInit() {


  }
  search(searchValue) {
    for (const dropdownItem of this.dropdownItems) {
      if (!searchValue) {
        dropdownItem.show();
      } else {
        if (this.match(dropdownItem)) {
          dropdownItem.show();
        } else {
          dropdownItem.hide();
        }
      }
    }
    const hasHighlightItems = _.filter(this.dropdownItems, (item: DropDownItem) => item.isActive === true);
    hasHighlightItems.length && _.map(this.dropdownItems, (item: DropDownItem) => {
      item.removeSelection(); return item;
    })
    this.filteredItems = _.filter(this.dropdownItems, (item: DropDownItem) => item.isHidden === false);

    if (this.settings.isGroup) {
      const groupBy = _.uniq(_.map(this.filteredItems, (item: DropDownItem) => item.groupBy));
      const difference = _.difference(_.map(this.dropdownTitles, (title: DropdownTitle) => title.title), groupBy);
      _.map(this.dropdownTitles, (title: DropdownTitle) => {
        if (_.contains(difference, title.title)) {
          title.hide();
        } else {
          title.show();
        }
        return title;
      });

    }
    this.focusFirstElement();
    this.afterFilter.emit(this.filteredItems);
  }
  match(dropdownItem: DropDownItem, searchOpts?: { searchFn: string, searchKey: string[] }) {

    let searchKey: string[] = _.uniq(this.settings.searchBy);
    let searchFn: string = this.settings.searchFn;
    if (searchOpts) {
      searchKey = _.uniq(searchOpts.searchKey);
      searchFn = searchOpts.searchFn;
    }

    const option = dropdownItem.item;
    let isNameContains;
    if (this.searchValue && option) {
      const keyboard = this.autocomplete.virtualKeyBoardRef.inputField.keyboard;
      let isMalayamOrManglish = _.contains(['malayalam', 'manglish'], keyboard);
      for (let i = 0; i < searchKey.length; i++) {
        isMalayamOrManglish = searchKey[i] === 'name' && isMalayamOrManglish;

        const searchValue = (isMalayamOrManglish && this.searchValue.length === 2 && this.searchValue.toLowerCase().substring(1, 2) === '\u0d4d') ? this.searchValue.toLowerCase().substring(0, 1) : this.searchValue.toLowerCase().trim();
        if (searchFn === '===') {
          isNameContains = option[searchKey[i]].toLowerCase() === searchValue;
        } else {

          isNameContains = option[searchKey[i]].toLowerCase()[searchFn](searchValue);
        }
        if (isNameContains) {
          return isNameContains;
        }
      }
    }
    return !!isNameContains;
  }
  focusFirstElement() {
    if (this.settings.isFocusFirstElement && this.filteredItems.length) {
      if (this.filteredItems[0]) {
        this.filteredItems[0].selection();
        this.filteredItems[0].scrollIntoView(false);
      }
    }
  }
  register(dropdownItem: DropDownItem) {

    this.dropdownItems.push(dropdownItem);
    this.filteredItems.push(dropdownItem);
    this.afterFilter.emit(this.filteredItems);

  }
  unregister(dropdownItem: DropDownItem) {
    this.dropdownItems = this.dropdownItems.filter(current => current !== dropdownItem);
    this.filteredItems = this.dropdownItems;
    this.afterFilter.emit(this.filteredItems);

  }
  registerTitle(dropdownTitle: DropdownTitle) {

    this.dropdownTitles.push(dropdownTitle);
    this.afterFilter.emit(this.filteredItems);

  }
  unregisterTitle(dropdownTitle: DropdownTitle) {
    this.dropdownTitles = this.dropdownTitles.filter(current => current !== dropdownTitle);
    this.afterFilter.emit(this.filteredItems);

  }
  ngOnDestroy(): void {
    this.componentDestroySubject.next(true);
    this.componentDestroySubject.complete();

  }
}
